export default __webpack_public_path__ + "static/media/homepagemockup.230a111c.png";